<template>
  <v-container fluid class="pt-4 pb-4 journal-entry">
    <v-layout wrap>
      <v-flex xs12>
        <v-layout align-center>
          <v-flex class="title">
            {{ value.state_of_procedure }}
            <small class="body-1">
              {{ value.date | toLocaleDateString }}
            </small>
          </v-flex>
          <v-spacer />
          <v-btn icon small :disabled="!value.files.length" @click="value.downloadZip()">
            <v-icon small>cloud_download</v-icon>
          </v-btn>
          <template v-if="$isSuperuser()">
            <v-btn icon small @click.prevent.stop="$emit('edit', value)">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn icon small @click.prevent.stop="$emit('delete', value)">
              <v-icon small color="red">delete</v-icon>
            </v-btn>
          </template>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-if="value.comment">
        <p class="content">{{ value.comment }}</p>
      </v-flex>
      <v-flex xs12>
        <FilesTable v-if="value.files.length" v-model="value.files" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'JournalEntry',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.content {
  white-space: pre-line;
}
</style>
